import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string;
  message?: string;
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  color = '#0d9488',
  message,
  fullScreen = false
}) => {
  const sizeMap = {
    small: 16,
    medium: 32,
    large: 48,
  };
  
  const spinnerSize = sizeMap[size];
  
  const spinner = (
    <div style={{
      display: 'inline-block',
      width: `${spinnerSize}px`,
      height: `${spinnerSize}px`,
      border: `${Math.max(2, spinnerSize / 8)}px solid ${color}20`,
      borderTop: `${Math.max(2, spinnerSize / 8)}px solid ${color}`,
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite',
    }} />
  );
  
  const content = (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '12px',
    }}>
      {spinner}
      {message && (
        <div style={{
          fontSize: size === 'small' ? '12px' : size === 'medium' ? '14px' : '16px',
          color: '#6c757d',
          fontWeight: '500',
        }}>
          {message}
        </div>
      )}
    </div>
  );
  
  if (fullScreen) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      }}>
        {content}
        <style>
          {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }
  
  return (
    <>
      {content}
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default LoadingSpinner;
